export const white = {
  100: "#FFF",
  200: "#828282"
};

export const black = {
  100: "#030303",
  200: "#999999"
};
